import { PlaceholdersId, TFComponent } from '@types';

import { LateralMenuPlaceholder } from './lateralMenu';

export const lateralMenu: TFComponent = {
	component: LateralMenuPlaceholder,
	id: PlaceholdersId.lateralMenu,
	name: 'lateralMenu',
};
